/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { SlsOrdFServ01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const slsOrdFServ01ShowSyncSettingLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const slsOrdFServ01ShowSyncSettingSuccess = (state, { syncSetting }) => ({
  ...state,
  syncSetting
});

export const slsOrdFServ01ShowBatchJobStatusSuccess = (state, { batchJobStatus }) => ({
  ...state,
  batchJobStatus
});

export const slsOrdFServ01ImportLoading = (state, { boolean }) => ({
  ...state,
  importIsLoading: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [SlsOrdFServ01Types.SLS_ORD_F_SERV01_SHOW_SYNC_SETTING_LOADING]: slsOrdFServ01ShowSyncSettingLoading,
  [SlsOrdFServ01Types.SLS_ORD_F_SERV01_SHOW_SYNC_SETTING_SUCCESS]: slsOrdFServ01ShowSyncSettingSuccess,
  [SlsOrdFServ01Types.SLS_ORD_F_SERV01_SHOW_BATCH_JOB_STATUS_SUCCESS]: slsOrdFServ01ShowBatchJobStatusSuccess,
  [SlsOrdFServ01Types.SLS_ORD_F_SERV01_IMPORT_LOADING]: slsOrdFServ01ImportLoading
});
